import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import ShieldIcon from '@mui/icons-material/Shield';
import { fetchSecurity, logoutAllDevices } from './api.js';

// Setelan > Keamanan: penjelasan login dari luar kantor (kode verifikasi
// lewat DM Discord) dan tombol keluar dari semua perangkat.
export default function SecuritySettings({ open }) {
    const [info, setInfo] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(null);

    useEffect(() => {
        if (!open) return;
        setError(null);
        setDone(null);
        fetchSecurity().then(setInfo).catch((e) => setError(e.message));
    }, [open]);

    const onLogoutAll = async () => {
        if (!window.confirm('Keluar dari SEMUA perangkat, termasuk perangkat ini? Semua perangkat harus login ulang.')) return;
        setBusy(true);
        setError(null);
        try {
            // Sesi ini ikut dicabut: request berikutnya otomatis diarahkan ke halaman login.
            await logoutAllDevices();
            setDone('Semua sesi dicabut. Perangkat ini akan diminta login ulang.');
        } catch (e) {
            setError(e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ShieldIcon fontSize="small" color="success" />
                <Typography variant="subtitle2">Keamanan</Typography>
            </Box>
            {!info && !error && <Box sx={{ py: 2 }}><CircularProgress size={22} /></Box>}
            {info && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Login dari luar kantor (halaman Drive) selalu meminta kode verifikasi 6 digit yang dikirim bot lewat DM Discord,
                    selain password. Sesi dari luar kantor berlaku {info.remoteSessionDays} hari, setelah itu wajib login ulang.
                    {info.office ? ' Perangkat ini sedang di jaringan kantor.' : ' Perangkat ini sedang login dari luar kantor.'}
                </Typography>
            )}
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
                Dapat kode login padahal tidak sedang login, atau HP/laptop hilang? Cabut semua sesi, lalu ganti password.
            </Typography>
            <Button variant="outlined" color="error" sx={{ mt: 1 }} disabled={busy} onClick={onLogoutAll}>Keluar dari semua perangkat</Button>
            {done && <Alert severity="success" sx={{ mt: 1.5 }}>{done}</Alert>}
            {error && <Alert severity="error" sx={{ mt: 1.5 }}>{error}</Alert>}
        </Box>
    );
}
